

import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';



export interface CountParameter extends Parameter {
    searchTerm: number;
    orderBy: string;
  
}

export interface Count {
    Id?: any;
   
    Name: string;
    Type: string;
    TenantId: any;
    BranchId: any;
    
  parameters?: CountParameter[];
  links?: any;
}

export abstract class CountData {
  //abstract fireRequest(data: CountryMst, method: string): Observable<any>;
  abstract list(url: string): Observable<Count[]>;
  abstract create(url: string,data: Count): Observable<any>;
  abstract update(url: string,data: Count): Observable<any>;
  abstract delete(url: string): Observable<any>;
}